var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"dataRight"},[_c('div',{staticClass:"stateTable"},[_c('el-scrollbar',[_c('ChangeTime',{ref:"changeTime"})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }